const colorKeyContent = {
  supply: [
    {
      text: 'HIGH HOUSING SHORTAGE',
      fill: 'colorKey__highShortage'
    },
    {
      text: 'HOUSING SHORTAGE',
      fill: 'colorKey__shortage'
    },
    {
      text: 'SUFFICIENT',
      fill: 'colorKey__sufficient'
    },
    {
      text: 'EXCESS SUPPLY',
      fill: 'colorKey__jobloss'
    }
  ],
  affordability: [
    {
      text: 'UNAFFORDABLE',
      fill: 'colorKey__unaffordable'
    },
    {
      text: 'AFFORDABLE',
      fill: 'colorKey__affordable'
    },
    {
      text: 'VERY AFFORDABLE',
      fill: 'colorKey__veryAffordable'
    },
    {
      text: 'EXTREMELY AFFORDABLE',
      fill: 'colorKey__extremeAffordable'
    }
  ],
  appreciation: [
    {
      text: '36%+',
      text2: 'GROWTH',
      fill: 'colorKey__growth4'
    },
    {
      text: '26-35%',
      text2: 'GROWTH',
      fill: 'colorKey__growth3'
    },
    {
      text: '16-25%',
      text2: 'GROWTH',
      fill: 'colorKey__growth2'
    },
    {
      text: '0-15%',
      text2: 'GROWTH',
      fill: 'colorKey__growth1'
    },
    {
      text: 'LOSS',
      fill: 'colorKey__loss'
    }
  ],
  forecast: [
    {
      text: 'DROP',
      fill: 'colorKey__drop'
    },
    {
      text: '0-10%',
      text2: 'GROWTH',
      fill: 'colorKey__growth10'
    },
    {
      text: '11-20%',
      text2: 'GROWTH',
      fill: 'colorKey__growth20'
    },
    {
      text: '21-30%',
      text2: 'GROWTH',
      fill: 'colorKey__growth30'
    },
    {
      text: '31%+',
      text2: 'GROWTH',
      fill: 'colorKey__growth40'
    }
  ]
};

export default colorKeyContent;
